import React, { useState, useEffect } from 'react';
import { auth } from './firebaseConfig';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, onAuthStateChanged, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { dataService } from './services/dataService';
import { initInboxService } from './utils/inboxStorage';
import { FeatureFlagProvider } from './contexts/FeatureFlagContext';
import { ChatDockProvider } from './contexts/ChatDockContext';
import AppLayout from './components/Layout/AppLayout';
import AuthScreen from './components/AuthScreen';
import GlobalDialog from './components/GlobalDialog';
import './App.css';

function App() {
  const [user, setUser]           = useState(null);
  const [loading, setLoading]     = useState(true);
  const [userData, setUserData]   = useState(null);
  const [userAiAccess, setUserAiAccess] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (u) => {
      setUser(u);
      setLoading(false);
      if (u) {
        dataService.setUser(u.uid);
        initInboxService(u.uid);
        dataService.createOrUpdateUser(u.uid, u.email).catch(console.error);
        try {
          const [ud, ai] = await Promise.all([
            dataService.getUserData(u.uid),
            dataService.getUserAiAccess(u.uid)
          ]);
          setUserData(ud);
          setUserAiAccess(ai);
        } catch (e) { console.error(e); }
        const savedTheme = localStorage.getItem('theme') || 'light';
        document.documentElement.setAttribute('data-theme', savedTheme);
      } else {
        setUserData(null);
        setUserAiAccess(false);
        initInboxService(null);
      }
    });
    return unsubscribe;
  }, []);

  const handleAuth = async (email, password, isLogin, username) => {
    if (isLogin) {
      await signInWithEmailAndPassword(auth, email, password);
    } else {
      const cred = await createUserWithEmailAndPassword(auth, email, password);
      if (username) await dataService.createOrUpdateUser(cred.user.uid, email, username);
    }
  };

  const handleGoogleAuth = async () => {
    const provider = new GoogleAuthProvider();
    const cred = await signInWithPopup(auth, provider);
    const u = cred.user;
    const name = u.displayName ? u.displayName.toLowerCase().replace(/\s+/g, '') : u.email.split('@')[0];
    await dataService.createOrUpdateUser(u.uid, u.email, name);
  };

  if (loading) return <div className="loading">Loading…</div>;
  if (!user)   return <AuthScreen onAuth={handleAuth} onGoogleAuth={handleGoogleAuth} />;

  return (
    <FeatureFlagProvider>
    <ChatDockProvider>
      <AppLayout
        user={user}
        userData={userData}
        userAiAccess={userAiAccess}
        onSignOut={() => signOut(auth)}
        onDataChanged={() => {}}
      />
      <GlobalDialog />
    </ChatDockProvider>
    </FeatureFlagProvider>
  );
}

export default App;
